import React from 'react';
import { Button, Row, Col } from 'reactstrap';

const DashboardTourStep = ({ onNext, onBack }) => {
  const features = [
    {
      icon: 'mdi-account-group',
      title: 'Leads',
      description: 'Claryo gestiona y nutre tus leads automáticamente. Tú defines los criterios, Claryo ejecuta el seguimiento.',
      color: '#E9553E'
    },
    {
      icon: 'mdi-automation',
      title: 'Automatizaciones',
      description: 'Diseña tus flujos de venta aquí. Claryo los ejecuta sin intervención manual todos los días.',
      color: '#28a745'
    },
    {
      icon: 'mdi-email-multiple',
      title: 'Campañas',
      description: 'Crea campañas de email. Claryo las envía, rastrea y optimiza automáticamente.',
      color: '#007bff'
    },
    {
      icon: 'mdi-calendar-clock',
      title: 'Calendario',
      description: 'Claryo programa y gestiona tus eventos, reuniones y recordatorios automáticamente.',
      color: '#ffc107'
    }
  ];

  return (
    <div className="onboarding-step tour-step-fullscreen">
      <Row className="justify-content-center">
        <Col lg={11} xl={10}>
          <div className="step-header-fullscreen mb-4">
            <Button 
              color="link" 
              className="back-btn"
              onClick={onBack}
            >
              <i className="mdi mdi-arrow-left"></i> Volver
            </Button>
            
            <h1 className="step-title-large mb-2">
              Tu centro de control
            </h1>
            <p className="step-description-large">
              Aquí es donde Claryo ejecuta tus procesos de venta
            </p>
          </div>

          <Row className="g-3 mb-4">
            {features.map((feature, index) => (
              <Col md={6} key={index}>
                <div className="feature-card-fullscreen">
                  <div 
                    className="feature-icon-large"
                    style={{backgroundColor: `${feature.color}15`, color: feature.color}}
                  >
                    <i className={`mdi ${feature.icon}`}></i>
                  </div>
                  <h4 className="feature-title">{feature.title}</h4>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </Col>
            ))}
          </Row>

          <div className="tour-note-fullscreen">
            <div className="note-icon">
              <i className="mdi mdi-lightbulb-on-outline"></i>
            </div>
            <div className="note-content">
              <h5>Recuerda el principio fundamental</h5>
              <p className="mb-0">
                <strong>Tú defines la estrategia.</strong> Claryo la ejecuta todos los días sin depender de personas.
              </p>
            </div>
          </div>

          <div className="form-actions-fullscreen mt-4">
            <Button 
              color="primary" 
              size="lg"
              className="onboarding-primary-btn w-100"
              onClick={onNext}
            >
              Continuar
              <i className="mdi mdi-arrow-right ms-2"></i>
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardTourStep;

